import React from "react";
import { Flex, Typography } from "antd";

const { Text } = Typography;

const MastercardSectionHeader = () => (
  <Flex vertical gap={4} className="mc-section-header">
    <Text strong style={{ fontSize: 18 }}>
      Mastercard Monitoring Programs (ECP & EFM)
    </Text>
    <Text type="secondary">
      Track your Excessive Chargeback Program (ECP) and Excessive Fraud
      Merchant (EFM) status across all card-not-present transactions.
    </Text>
  </Flex>
);

export default MastercardSectionHeader;
